import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";


const Check = () => {


    useEffect(() => {
        Swal.fire({
            icon: "success",
            title: "Loading...",
            text: "Checking.. You Credintial",
            focusConfirm: false,
        });
        
        onFormSubmit()
    }, [])

  const onFormSubmit = async () => {
    
     
      const sendData = {
          OrgId: Number(53),
          PhoneNo: sessionStorage.getItem("loginphone"),
          Password: sessionStorage.getItem("loginpass"),
          VURL: window.location.href,
          WebHeader: 'MyProfileFile',
          Server: window.location.origin

      }
   
     
      await fetch(process.env.REACT_APP_API_LINK+'api/Main/UserVerify', {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(sendData)

      })
          .then(response => response.json())
          .then(
              data => {

          if (data.firstName !== null) {
          localStorage.setItem("accessToken", "token");
          localStorage.setItem('orgId', 53);
          localStorage.setItem('userId', data.userId);
          localStorage.setItem('Maincatid', data.mainCatID);
          localStorage.setItem('urole', data.urole);
          localStorage.setItem('OrderNo', data.orderNo);
          setTimeout(() => {
              window.history.pushState(
                  `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/user-profile-edit"}`,
                  "auth-login",
                  `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/user-profile-edit"}`
              );
              window.location.reload();
          }, 2000);
      }

         else {
              setTimeout(() => {
                  window.location.pathname = "/"
          }, 2000);
      }




              })

    




  };

  

  return (
    null
  );
};
export default Check;
